/* eslint-disable no-console */
/**
 * Browser logger. `debug` output (which can contain payroll data) only appears in development
 * builds; production builds keep warnings and errors only.
 */
const isDevelopment = process.env.NODE_ENV === "development";

export const logger = {
  debug: (...args: unknown[]) => {
    if (isDevelopment) console.debug(...args);
  },
  warn: (...args: unknown[]) => console.warn(...args),
  error: (...args: unknown[]) => console.error(...args),
};
